import { defineContent } from './defineContent.js';
import data from './install.json';
import { installSchema } from './install.schema.js';

export const install = defineContent(installSchema, data);
